<template>
  <div
    class="msg-long-msg"
    :class="{
      'select-none': selectNone
    }"
  >
    <div class="msg-c2b-ref" @click="handleRefMsgClick" v-if="isReplayMsg">
      <div class="msg-c2b-ref-meta">
        <div class="msg-c2b-ref-name">{{ formatNickname }}:</div>
        <div class="msg-c2b-ref-time">{{ formatTime }}</div>
      </div>
      <div class="msg-c2b-ref-content">{{ sourceMsg.bytes_summary }}</div>
    </div>
    <span v-html="processedText"></span>
    <msg-text-translate :data="longMessage" v-if="isTransLate()"></msg-text-translate>
  </div>
</template>

<script>
import axios from 'axios';
import Utils from '@/utils/string';

import { IMSDK, SDKUtils } from '@/imsdk/index.ts';
import globalWin from '@/utils/globalWin';
import MsgTextTranslate from '../MsgTextTranslate';
import dayjs from 'dayjs';

export default {
  props: {
    data: Object,
    selectNone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedText: '',
      longMessage: '',
    };
  },
  components: { MsgTextTranslate },
  watch: {
    // processedText 为实际展示的文本，这里需要保存该文本在消息回复中使用
    processedText(newValue) {
      // 设置一个私有变量供消息回复中使用
      /* eslint-disable no-underscore-dangle */
      this.data._processedText = this.getCopyText(newValue);
    },
  },
  computed: {
    formatTime() {
      const second = this.sourceMsg?.uint64_time;
      return dayjs(second).format('HH:mm');
    },
    formatNickname() {
      const dir = this.sourceMsg?.uint32_msg_direction;
      if (dir === 1 || dir === '访客') {
        return '我';
      }
      return '客服';
    },
    sourceMsg() {
      /* eslint-disable max-len */
      return this.data.$_sourceMsg || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.qd_source_msg;
    },
    hasMsgId() {
      return this.data?.$_sourceMsg?.str_current_qidian_msg_unique_id || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.str_current_qidian_msg_unique_id;
    },
    isReplayMsg() {
      /* eslint-disable max-len */
      return this.data.$_sourceMsg || this.data?.msgHead?.msg_third_app_info?.bytes_third_app_buf?.bytes_crm_buf?.qd_source_msg?.str_reference_qidian_msg_unique_id;
    },
    processedText() {
      // 过滤html，仅保留 a ；
      let text = Utils.filterHTML(this.longMessage);
      text = Utils.emojiEscape(text);
      // 当文本中不包括 a连接时，才进行转义
      if (text.indexOf('<a ') === -1) {
        text = Utils.urlEscape(text);
      }
      return Utils.coverEmojIndex2EmojiImg(text);
    },
  },
  async mounted() {
    if (this.data.previewContent) {
      this.longMessage = this.data.previewContent;
      return;
    }

    if (this.data.compressed) {
      // 如果是SDK通路的被压缩的长文本
      try {
        this.longMessage = await SDKUtils.downloadAndParseLongText(this.data);
      } catch (ex) {
        console.error(ex);
        this.longMessage = '[获取消息内容异常]';
      }
    } else {
      const resPath = await SDKUtils.getDownloadUrl(this.data, IMSDK.OBJTYPES.OBJ_LONGTEXT);
      if (resPath) {
        // 为什么此处要设置[transformResponse]? —— 因为当发送的文本内容为纯数字是，axios会将其json化，变成了[Infinity]。
        // 因此要强制设置返回值type为string
        // https://github.com/axios/axios/issues/2791#issuecomment-599374457
        axios.get(resPath, {
          responseType: 'text',
          transformResponse: [data => data],
        }).then((response) => {
          if (response.status === 200) {
            this.longMessage = response.data;
            this.onLoad();
          } else {
            this.longMessage = '[获取消息内容异常]';
          }
        })
          .catch(() => {
            this.longMessage = '[获取消息内容异常]';
          });
      } else {
        this.longMessage = '[获取消息内容异常]';
      }
    }
  },
  methods: {
    handleRefMsgClick() {
      this.$emit('onReplayMsgClick', this.sourceMsg?.str_reference_qidian_msg_unique_id);
    },
    getCopyText(html) {
      let str = '';
      const el = document.createElement('div');
      el.innerHTML = html;
      el.childNodes.forEach((node) => {
        console.dir(node, 'emojiText-image');
        if (node.nodeName === 'IMG' && node.className === 'emojiText-image') {
          str += '[表情]';
        }
        if (node.nodeName === '#text') {
          str += node.nodeValue;
        }
        // 按说 emoji 表情处理
        if (node.nodeName === 'SPAN' && node.className === 'emoji') {
          str += '[表情]';
        }
      });
      return str;
    },

    /** */
    onLoad() {
      globalWin.checkIfNeedScrollToBottom(this.data.fromHisotry);
    },

    isTransLate() {
      // const { translateSwitch, translateAuto, isTranslate } = globalWin.translate;
      const { translateSwitch, translateAuto  } = globalWin.translate || {};
      // return +translateSwitch && (+translateAuto || +isTranslate) && !this.data.mine;
      return +translateSwitch && translateAuto && !this.data.mine;
    },
  },
};
</script>

<style lang="less" scoped>
.msg-long-msg {
  font-family: @emoji-family, "PingFangSC-Regular", "Microsoft YaHei",
    "sans-serif";
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  border-radius: 0px 6px 6px 6px;
  word-wrap: break-word;
  white-space: pre-wrap;
  text-align: left;
  max-width: 300px;
  &.select-none {
    user-select: none;
    span {
      user-select: none;
    }
  }
  &.pc.pc-not-frame{
     max-width: 460px;
  }
  span {
    user-select: text;
    -webkit-user-select: text;
    line-height: 22px;
  }
  a {
    color: #262d3d;
    text-decoration: underline;
  }
  .emoji {
    font-size: 20px;
    vertical-align: -2px;
  }

  &.pc{
    font-family: "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  &.pc.pc-not-frame{
     max-width: 460px;
  }
}

.msg-c2b{
  .msg-long-msg{
    color: #fff;
    ::v-deep a{
      color: #fff;
    }
  }
}
/deep/
.emojiText-image {
  height: 20px;
  vertical-align: top;
  min-width: 20px;
  max-width: 20px;
}

.msg-c2b-ref {
  opacity: .4;
  cursor: pointer;
  border-bottom: 1px solid rgba(255,255,255,.4);
  margin-bottom: 4px;
  padding-bottom: 4px;
  min-width: 130px;
  -webkit-tap-highlight-color: transparent;
  &.b2c {
      border-bottom: 1px solid #CDD0D9;
  }
  &-meta {
      display: flex;
      justify-content: space-between;
  }
  &-name {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: 10px;
  }
  &-content {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-break: break-all;
  }
}
</style>
